import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Optional: for global styles not covered by App.css
import App from './App';

const rootElement = document.getElementById('root');

// Add a null check for the root element
if (!rootElement) {
  throw new Error("Failed to find the root element");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 